import { getDeliveryShopId } from '@epicuro-next/utilities';
import {
  BasketItem,
  BasketUpdateItem,
} from 'graphql-api/baskets-api-interfaces';

import { BasketUpdateShops } from '../../models';

// we need a map function BasketItem => BasketUpdateItem, so it fits into BasketUpdateShops
// BasketUpdateShops is our own custom type, so check if it's possible to make it simpler
export const basketItemsToShops = (
  map: (basketItem: BasketItem) => BasketUpdateItem,
) => (basketItems: BasketItem[]): BasketUpdateShops => {
  return basketItems.reduce((shops, basketItem) => {
    const shopId = getDeliveryShopId(basketItem);
    const existingShopGroup = shops[getDeliveryShopId(basketItem)];
    const item = map(basketItem);
    if (!existingShopGroup) {
      return {
        ...shops,
        [shopId]: [item],
      };
    }
    return {
      ...shops,
      [shopId]: [...existingShopGroup, item],
    };
  }, {} as BasketUpdateShops);
};
